import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !["width", "height"].includes(prop),
})(({ width, height, theme }) => ({
  borderRadius: theme.shape.customBorderRadius[3], //25px
  color: theme.palette.primary.white,
  backgroundColor: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  width,
  height,

  "&:hover": {
    backgroundColor: theme.palette.primary.mainHover,
    borderColor: theme.palette.primary.mainHover,
    color: theme.palette.primary.white,
  },
  "&:active": {
    backgroundColor: theme.palette.primary.black,
    borderColor: theme.palette.primary.black,
    color: theme.palette.primary.white,
  },
  "&:disabled": {
    backgroundColor: theme.palette.primary.greyThread,
    border: `1.5px solid ${theme.palette.primary.greyThread}`,
    color: theme.palette.primary.greySecound,
    cursor: "not-allowed",
  },
}));

export const SolidButton = ({
  iconStart,
  iconEnd,
  width,
  height,
  children,
  ...rest
}) => {
  return (
    <StyledButton
      startIcon={iconStart}
      endIcon={iconEnd}
      width={width}
      height={height}
      {...rest}
    >
      {children}
    </StyledButton>
  );
};
